import { Icon } from '@chakra-ui/react';
import { AiOutlineSearch } from 'react-icons/ai';

const SearchIcon = (props) => {
  return (
    <Icon as={AiOutlineSearch} {...props} />
  );
}

export default SearchIcon;